const skillDisplayNames: Record<string, string> = {};

export function getSkillDisplayNameFromPath(path: string): string | null {
  if (!path) return null;

  const normalizedPath = path.replace(/\\/g, '/');
  const segments = normalizedPath.split('/').filter(Boolean);
  const lastSegment = segments.at(-1)?.toLowerCase();

  if (lastSegment !== 'skill.md') {
    return null;
  }

  const skillName = segments.at(-2);

  if (!skillName) {
    return null;
  }

  return skillDisplayNames[skillName] ?? skillName;
}
